// extracted by mini-css-extract-plugin
export default {"blocks_numbers":"blocks_blocks_numbers__4rUJM","info_content":"blocks_info_content__FBj5V"};